<template>
    <div class="lottery_modal_container">
        <!-- <div class="home_btn" @click="backHome">
            <img :src="defultCloseIcon" alt="" srcset="" />
        </div> -->
        <div
            v-if="!loading"
            style="
                display: flex;
                justify-content: center;
                align-items: center;
                height: 100vh;
            "
        >
            <div v-if="!showMessageModal">
                <img v-show="!showAnimate"
                    :src="defultGasha"
                    style="width: 100%"
                />
                <div v-show="showAnimate">
                    <img :src="gimg" style="width: 100%" v-for="(gimg , k) in gasha_ani" :key="k"  v-show="k == aniIndex" />
                </div>              
            </div>

            <div class="dialog" v-if="showMessageModal">
                <div class="dialog_content">
                    
                    <div
                        class="dialog_alert"
                        :style="{ backgroundImage: defultWinningDialog }"
                    >
                        <div class="text">
                            <template v-if="msg == ''">
                                恭喜您<br />
                                中了 XXX 元<br />
                            </template>
                            <template v-else>
                                {{ msg }}<br />
                                {{ msg2 }}<br />
                            </template>                            
                        </div>

                        <div class="close_btn">
                            <span style="font-size: 16px; color: #b28247"
                                >{{ $t("turn.count") }}：{{ memberCount }}</span
                            ><br />
                            <img
                                @click="closeMessage"
                                :src="defultWinningDialogButton"
                                style="width: 80px"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import bg from "../assets/hongbao/img/modal_bg3.png";
import gasha01png from "../assets/defult/img/gasha/Gacha01.png";
import gasha02png from "../assets/defult/img/gasha/Gacha02.png";
import gasha03png from "../assets/defult/img/gasha/Gacha03.png";
import gasha04png from "../assets/defult/img/gasha/Gacha04.png";
import gasha05png from "../assets/defult/img/gasha/Gacha05.png";
import gasha06png from "../assets/defult/img/gasha/Gacha06.png";
import gasha07png from "../assets/defult/img/gasha/Gacha07.png";
import gasha08png from "../assets/defult/img/gasha/Gacha08.png";
import gasha09png from "../assets/defult/img/gasha/Gacha09.png";
import gasha10png from "../assets/defult/img/gasha/Gacha10.png";
import gasha11png from "../assets/defult/img/gasha/Gacha11.png";
import gasha12png from "../assets/defult/img/gasha/Gacha12.png";
import gasha13png from "../assets/defult/img/gasha/Gacha13.png";
import gasha14png from "../assets/defult/img/gasha/Gacha14.png";
import gasha15png from "../assets/defult/img/gasha/Gacha15.png";
import gasha16png from "../assets/defult/img/gasha/Gacha16.png";
import gasha17png from "../assets/defult/img/gasha/Gacha17.png";
import gasha18png from "../assets/defult/img/gasha/Gacha18.png";
import gasha19png from "../assets/defult/img/gasha/Gacha19.png";
import gasha20png from "../assets/defult/img/gasha/Gacha20.png";
export default {
    name : 'GashaModel',
    props: {
        showGashaDialog : {
            type: Boolean,
            default: true,
        },
        memberCount: {
            type: Number,
        },
        userData: {},
        awardsList: {
            type: Array,
            default: function () {
                return [];
            },
        },
        loading: {
            type: Boolean,
            default: true,
        },
        propsMsg: "",
        propsMsg2: "",
        templateImage: "",
        code: "",
        lang: {
            type: String,
            default: "zh-tw",
        },
    },
    watch: {
        templateImage(newData, oldData) {
            this.templateImage = newData;
            this.generateDynamicPrizes();
        },
        showGashaDialog(nv ,ov) {
            // console.log("nv")
            // console.log(nv)
            // console.log("nv")
            if(nv) {
                let chooseHongbao = this.chooseHongbao()
                if (chooseHongbao == true) {
                    this.getWinning()
                    setTimeout(() => {
                            this.startAnimate()
                        },1000)
                }else{
                    this.showAnimate = false
                    this.aniIndex = 0;
                    this.showMessageModal = true
                }
            }
        }
    },
    data() {
        return {
            gasha_ani: [
                gasha01png,
                gasha02png,
                gasha03png,
                gasha04png,
                gasha05png,
                gasha06png,
                gasha07png,
                gasha08png,
                gasha09png,
                gasha10png,
                gasha11png,
                gasha12png,
                gasha13png,
                gasha14png,
                gasha15png,
                gasha16png,
                gasha17png,
                gasha18png,
                gasha19png,
                gasha20png,
            ],
            aniIndex : 0,
            showAnimate : false,
            showMessageModal: false,
            msg: "",
            msg2: "",
            wingHongbaoModal: "",
            rolling: false,
            backgroundUrl: `url(${bg})`,
            
            defultGasha: require("../assets/defult/img/gasha/Gacha01.png"),
            // defultCloseIcon: require("../assets/defult/img/closebtn.png"),
            defultWinningDialogButton: require("../assets/hongbao/img/comfirBtnGa" +
                this.lang +
                ".png"),
            defultWinningDialog: `url(${bg})`,
        };
    },
    mounted() {},
    computed: {},
    methods: {
        startAnimate() {
            this.showAnimate = true
            let length = this.gasha_ani.length;
            let animateFn = () => {
                if (this.aniIndex < length - 1) {
                    this.aniIndex++;
                    setTimeout(() => {
                        window.requestAnimationFrame(animateFn);
                    }, 90);
                } else {
                    cancelAnimationFrame(animateFn);
                    setTimeout(() => {
                        this.showAnimate = false
                        this.aniIndex = 0;
                        this.showMessageModal = true
                    },2000)
                }
            }
            ///////////////////////////////
            // this.getWinning() //開始抽獎
            // this.chooseHongbao()
                animateFn() //跑動畫
            ///////////////////////////////
        },
        generateDynamicPrizes() {
            if (this.templateImage != "") {
                const json_image = JSON.parse(this.templateImage);
                for (const [key, value] of Object.entries(json_image)) {
                    switch (key) {
                        case "WinningDialogButton":
                            this.defultWinningDialogButton = value;
                            break;
                        case "WinningDialog":
                            this.defultWinningDialog = `url(${value})`;
                            break;
                        default:
                            break;
                    }
                }
            }
        },
        chooseHongbao() {
            if (this.code != "0") {
                this.showMessageModal = true;
                this.msg = this.propsMsg;
                this.msg2 = this.propsMsg2;
                return false
            } else {
                //如果次數為0 不得抽獎
                if (this.memberCount === 0 || this.memberCount === null) {
                    this.msg = this.$t("turn.zero");
                    this.msg2 = "";
                    // 如果尚在抽獎中不執行任何動作
                } else {
                    if (this.rolling) {
                        this.msg = this.$t("turn.drawing");
                        this.msg2 = "";
                        return;
                    }
                    //this.getWinning();
                    return true
                }
            }
        },
        getWinning() {
            this.rolling = true;
            let postData = {
                Token: this.userData.token,
                PEid: this.userData.peid,
            };
            fetch("/api/drawEvents", {
                method: "POST",
                body: JSON.stringify(postData),
            })
                .then((res) => res.json())
                .then((res) => {
                    if (res.code == "0") {
                        this.roll(res.data);
                        return true
                    } else {
                        this.showMessageModal = true;
                        this.msg = this.$t("turn." + res.data);
                        this.msg2 = this.$t("turn.contact");
                        this.rolling = false;
                        return false
                    }
                });
        },
        roll(result) {
            if (isNaN(result)) {
                let jresult = JSON.parse(result);
                let result_name = Object.keys(jresult);
                result = result_name[0];
            }
            setTimeout(() => {
                // this.showMessageModal = true;
                this.msg = this.$t("turn.congratulations");
                this.msg2 = this.awardsList[result];

                this.rolling = false;
                this.$emit("rollDone", 1);
                this.button_disabled = false;
            }, 200);
            return true
        },
        backHome() {
            this.$emit("closeDialog", false);
        },
        closeMessage() {
            this.$emit("closeDialog", false);
            this.showMessageModal = false;
        },
    },
};
</script>


<style scoped>
@import "../assets/hongbao/css/style.css";
@import "../assets/hongbao/css/animate.css";
@import "../assets/hongbao/css/bootstrap.css";
.dialog_alert .text {
    height : 35% !important;
}
</style>



// WEBPACK FOOTER //
// src/components/gasha_modal.vue